import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Slider from '@mui/material/Slider'
import Stack from '@mui/material/Stack'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'
import VolumeDownIcon from '@mui/icons-material/VolumeDown'
import DashboardHeader from '../DashboardHeader'
// import { DEFAULT_ICONS } from 'src/constants/game'
import { altColor, altColorDarker, mainColor, mainColorDarker, shadow2 } from 'src/ui/theme/tokens'

type DashboardHeaderViewProps = {
  fullScreen: boolean
  musicIsPlaying: boolean
  volumeExpanded: boolean
  volumeLevel: number
  onTitleClick: () => void
  onToggleMusic: () => void
  onExpandVolume: (expanded: boolean) => void
  onVolumeChange: (value: number) => void
  appUserId?: number
  avatarMenuAnchorEl: HTMLElement | null
  avatarMenuOpen: boolean
  onAvatarMenuClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  onAvatarMenuClose: () => void
  onLogin: () => void
  onAccount: () => void
  showAdminOption?: boolean
  onAdmin?: () => void
  onLogout: () => void
}

const DashboardHeaderView: React.FC<DashboardHeaderViewProps> = ({
  fullScreen,
  musicIsPlaying,
  volumeExpanded,
  volumeLevel,
  onTitleClick,
  onToggleMusic,
  onExpandVolume,
  onVolumeChange,
  appUserId,
  avatarMenuAnchorEl,
  avatarMenuOpen,
  onAvatarMenuClick,
  onAvatarMenuClose,
  onLogin,
  onAccount,
  showAdminOption,
  onAdmin,
  onLogout,
}) => {
  return (
    <DashboardHeader
      fullScreen={fullScreen}
      onTitleClick={onTitleClick}
      mainColor={mainColor}
      mainColorDarker={mainColorDarker}
      altColor={altColor}
      altColorDarker={altColorDarker}
    >
      <Box
        display="flex"
        alignItems="center"
        onMouseEnter={() => !fullScreen && onExpandVolume(true)}
        onMouseLeave={() => onExpandVolume(false)}
      >
        {!fullScreen && musicIsPlaying ? (
          <Collapse in={volumeExpanded} orientation="horizontal">
            <Box sx={{ width: 100, px: 1 }}>
              <Slider
                aria-label="Music volume"
                size="small"
                value={volumeLevel}
                onChange={(_e, v) => onVolumeChange(v as number)}
              />
            </Box>
          </Collapse>
        ) : null}
        <IconButton
          aria-label={musicIsPlaying ? 'Mute music' : 'Enable music'}
          onClick={onToggleMusic}
          size="small"
        >
          {musicIsPlaying ? <VolumeUpIcon fontSize="small" /> : <VolumeOffIcon fontSize="small" />}
        </IconButton>
      </Box>
      {appUserId ? (
        <>
          <IconButton
            id="account-menu-button"
            aria-label="Account menu"
            aria-haspopup="true"
            aria-expanded={avatarMenuOpen}
            onClick={onAvatarMenuClick}
          >
            <Avatar
              alt="Account"
              sx={{
                width: 34,
                height: 34,
                borderRadius: '13px',
                background: '#ffe178',
                color: '#193b58',
                boxShadow: '0 2px 0 #c6af62',
              }}
            />
          </IconButton>
          <Menu
            anchorEl={avatarMenuAnchorEl}
            open={avatarMenuOpen}
            onClose={onAvatarMenuClose}
            MenuListProps={{ 'aria-labelledby': 'account-menu-button' }}
          >
            <MenuItem
              onClick={() => {
                onAvatarMenuClose()
                onAccount()
              }}
            >
              Account
            </MenuItem>
            {showAdminOption ? (
              <MenuItem
                onClick={() => {
                  onAvatarMenuClose()
                  onAdmin?.()
                }}
              >
                Admin
              </MenuItem>
            ) : null}
            <MenuItem
              onClick={() => {
                onAvatarMenuClose()
                onLogout()
              }}
            >
              Log out
            </MenuItem>
          </Menu>
        </>
      ) : (
        <Button
          variant="outlined"
          size="small"
          onClick={onLogin}
          sx={{ minWidth: 0, px: 1.5, fontSize: 12 }}
        >
          Log in
        </Button>
      )}
    </DashboardHeader>
  )
}
export default DashboardHeaderView
